import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { ActionButton } from './components/ActionButton';
import { BrandImage } from './components/BrandImage';
import { Description } from './components/Description';
import { Title } from './components/Title';
import { useSkinAnalyzerBrandData } from './hooks/useSkinAnalyzerBrandData';
import { useInitSkinAnalyzer } from './lib/hooks/useInitSkinAnalyzer';
import { openSkinAnalyzer } from './lib/skinAnalyzerScripts';
import { trackViewOrSelectPromotion } from './lib/tracking';
import { DescriptionAndActionWrapper, SkinAnalyserWrapper } from './styled';

const SkinAnalyser = () => {
  const { inView, ref } = useInView();

  const brand = useSkinAnalyzerBrandData();

  useInitSkinAnalyzer({
    inView,
    brand,
  });

  const onOpenSkinAnalyzer = () => {
    trackViewOrSelectPromotion(brand?.brandName, 'select_promotion');
    openSkinAnalyzer();
  };

  return (
    <SkinAnalyserWrapper ref={ref} onClick={onOpenSkinAnalyzer}>
      <BrandImage />

      <DescriptionAndActionWrapper>
        <Title />

        <Description />

        <ActionButton onOpenSkinAnalyzer={onOpenSkinAnalyzer} />
      </DescriptionAndActionWrapper>
    </SkinAnalyserWrapper>
  );
};

export default SkinAnalyser;
